import { FC } from 'react';
import cx from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';

import { SvgIcon } from '@/components';

import styles from './SidebarNavButton.module.sass';

interface SidebarNavButtonProps {
  iconName: string;
  text: string;
  onClick: () => void;
  className?: string;
  isLoading?: boolean;
}

const SidebarNavButton: FC<SidebarNavButtonProps> = ({
  iconName,
  text,
  onClick,
  className,
  isLoading = false,
}) => {
  const classes = cx(styles.button, className);

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading ? (
        <LoadingOutlined spin className={styles.icon} />
      ) : (
        <SvgIcon name={iconName} className={styles.icon} />
      )}
      <span className={styles.text}>{text}</span>
    </button>
  );
};

export default SidebarNavButton;
